/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * When the form was started
 * @export
 * @interface StartedAt
 */
export interface StartedAt {
}

/**
 * Check if a given object implements the StartedAt interface.
 */
export function instanceOfStartedAt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StartedAtFromJSON(json: any): StartedAt {
    return StartedAtFromJSONTyped(json, false);
}

export function StartedAtFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartedAt {
    return json;
}

export function StartedAtToJSON(value?: StartedAt | null): any {
    return value;
}

